module.exports = __webpack_public_path__ + "img/review_funnel_template1.9f2dbf95.png";